export const selectResult = (data) => data.Result;
